import * as React from 'react';
import images from 'react-payment-inputs/images';
import * as Icons from '../../../icons';

import { PaymentMethodViewProps } from './interface';
import { PaymentMethodMenu } from './payment-method-menu';
import { Styled } from './styled';


export const PaymentMethodLine: React.FC<PaymentMethodViewProps> = ({
  isBackup,
  isPrimary,
  isSubscription,
  onCardClick,
  menuItems,
  expiryString,
  cardType,
  cardLast4,
}) => {
  return (
    <Styled.PaymentMethodLineContainer
      isPrimary={isPrimary}
      isBackup={isBackup}
      isSubscription={isSubscription}
      onClick={onCardClick}
    >
      <Styled.CardType
        xmlns="http://www.w3.org/2000/svg"
        height='30'
        viewBox='0 0 24 16'
      >
        {images[cardType]}
      </Styled.CardType>
      <Styled.CardNumber>
        <span>••••</span>
        <span>••••</span>
        <span>••••</span>
        <span>{cardLast4}</span>
      </Styled.CardNumber>
      <Styled.ExpiredDate>{expiryString}</Styled.ExpiredDate>
      <Styled.CardStatus>
        {isPrimary ? 'Primary' : isBackup ? 'Backup' : ''}
      </Styled.CardStatus>
      <PaymentMethodMenu menuItems={menuItems} icon={Icons.HorizontalMenu} />
    </Styled.PaymentMethodLineContainer>
  );
};
